import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import { required, maxLength } from "vuelidate/lib/validators";
import store from "@/store";
import tinycolor from "tinycolor2";
import ValidationService from "@/services/ValidationService";
import Select2Multiple from 'v-select2-multiple-component';

const COLOR_INPUT_EMPTY_SWATCH = "#d0d0d0";

export default {
    name: "TransactionCategoryCreate",
    components: {
        MainLayout,
        Loading,
        Select2Multiple,
    },
    mixins: [ValidationService],
    data() {
        return {
            isLoading: false,
            submitted: false,
            disabled: false,
            categoryData: {
                category_name: "",
                color_code: "#000000",
                category_type: null,
                is_active: null,
            },
            transactionTypesOptions: CONFIG.TRANSACTION_TYPES_OPTIONS,
            CONFIG,
        };
    },
    computed: {
        colorPickerDisplay() {
            return this.normalizeColorInput(this.categoryData.color_code) || "";
        },
        /** Valid hex for <input type="color"> when no color is set yet. */
        colorPickerInputValue() {
            return this.colorPickerDisplay || COLOR_INPUT_EMPTY_SWATCH;
        },
        colorCodeInvalid() {
            if (!this.submitted) {
                return false;
            }
            return !this.isValidOptionalColor(this.categoryData.color_code);
        },
    },
    watch: {
        colorPickerInputValue: "syncColorPickerInput",
    },
    mounted() {
        this.$nextTick(this.syncColorPickerInput);
    },
    validations: {
        categoryData: {
            category_name: { required, maxLength: maxLength(255) },
            category_type: { required },
            is_active: { required },
        },
    },
    methods: {
        trimString(value) {
            return value != null ? String(value).trim() : "";
        },
        normalizeColorInput(colorInput) {
            const trimmed = this.trimString(colorInput);
            return trimmed || "";
        },
        isValidOptionalColor(colorInput) {
            const trimmed = this.trimString(colorInput);
            if (!trimmed) return true;

            const standardHexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
            if (!standardHexRegex.test(trimmed)) return false;

            const color = tinycolor(trimmed);
            if (!color.isValid()) return false;

            return color.toHexString();
        },
        syncColorPickerInput() {
            this.$nextTick(() => {
                const colorPickerElement = this.$refs.colorPicker;
                const pickerHexValue = this.colorPickerInputValue;
                if (
                    colorPickerElement &&
                    pickerHexValue != null &&
                    colorPickerElement.value !== pickerHexValue
                ) {
                    colorPickerElement.value = pickerHexValue;
                }
            });
        },
        onColorPicked(event) {
            this.categoryData.color_code = event.target.value;
        },
        goToList() {
            this.$router.push({ name: "transactionCategoryList" });
        },
        submitCreate() {
            this.submitted = true;
            this.disabled = true;
            this.$v.$touch();
            if (this.$v.$invalid || this.colorCodeInvalid) {
                this.disabled = false;
                return;
            }
            this.clearValidationErrors();
            this.isLoading = true;
            const payload = {
                category_name: this.categoryData.category_name,
                color_code: this.normalizeColorInput(this.categoryData.color_code) || null,
                category_type: this.categoryData.category_type,
                is_active: this.categoryData.is_active,
                created_id: store.state.user.id,
            };
            axios
                .post("/transactionCategory/create", payload)
                .then((response) => {
                    if (response.data.success == true) {
                        this.isLoading = false;
                        this.$notification.success(response.data.message, {
                            timer: 3,
                            position: "bottomCenter"
                        });
                        this.$router.push({ name: "transactionCategoryList" });
                    }
                })
                .catch(error => {
                    this.disabled = false;
                    if (error.response?.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else if (error.response?.status == 422) {
                        this.printValidationError(error.response);
                    }
                    this.isLoading = false;
                })
        },
    },
};
